<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增服务项目
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词(搜索标题，详情等)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="价格"
        prop="basic.price"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="备注"
        prop="basic.text"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleShelf(row)">
            {{row.step==1?'上架':'下架'}}
          </el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="{ cmd: 'edit', item: row }">
                  修改
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { findServiceList, removeService,updateService } from '@/api/chess'
import Edit from './edit.vue'
export default {
  name: 'ChessService',
  components: { Edit },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/chess/service') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleCommand(command) {
      switch (command.cmd) {
        case 'edit':
          this.handleEdit(command.item)
          break
        case 'delete':
          this.handleDelete(command.item)
          break
      }
    },
    handleShelf(row) {
      this.$baseConfirm(`你确定要${row.step==1?'上架':'下架'}服务：${row.title} 吗`, null, async () => {
        await updateService({ serviceId: row.serviceId,step: row.step==1?2:1 })
        this.$baseMessage(
          `${row.step==1?'上架':'下架'}服务成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.queryData()
      })
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    handleDelete(row) {
      this.$baseConfirm(
        `你确定要删除服务项目：${row.title} 吗`,
        null,
        async () => {
          await removeService({ serviceId: row.serviceId })
          this.$baseMessage(
            `删除服务项目成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          this.queryData()
        }
      )
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findServiceList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
